import { defineMessages } from 'react-intl';

export default defineMessages({
    stepCoverables: {
        id: 'gateway.PremierPL.wizard.step.Coverables',
        defaultMessage: 'Coverables'
    },
    questions: {
        id: 'gateway.PremierPL.wizard.step.Questions',
        defaultMessage: 'Questions'
    },
    stepCoverages: {
        id: 'gateway.PremierPL.wizard.step.Coverages',
        defaultMessage: 'Coverages'
    },
    exposures: {
        id: 'gateway.PremierPL.wizard.step.Exposures',
        defaultMessage: 'Exposures'
    },
    anErrorOccurred: {
        id: 'quoteandbind.PremierPL.wizard.error',
        defaultMessage: 'Something went wrong during this process.'
    },
    anErrorOccurredTitle: {
        id: 'quoteandbind.PremierPL.wizard.error.title',
        defaultMessage: 'Error'
    },
    saveQuoteError: {
        id: 'quoteandbind.PremierPL.wizard.Unable to quote',
        defaultMessage: 'Unable to quote'
    },
    saveQuoteErrorMessage: {
        id: 'quoteandbind.PremierPL.wizard.An error occurred while attempting to quote.',
        defaultMessage: 'An error occurred while attempting to quote.'
    }
});
